import React, {useState} from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import {Button, Grid, Typography, Paper, FormControl, InputLabel, Select, MenuItem, FormHelperText, Alert, Snackbar} from '@mui/material';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import InputAdornment from '@mui/material/InputAdornment';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Card from '@mui/joy/Card';
import CardCover from '@mui/joy/CardCover';
import LinearProgress from '@mui/material/LinearProgress';
import Swal from 'sweetalert2';

import Autocomplete from '@mui/material/Autocomplete';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import {
    sellerLists,
    gemtypeLists,
    shapeLists,
    colorLists,
    clarityLists,
    originLists,
    treatmentLists,
    certs
} from '../utils/Utils';
import {CreateTitle,CreateParagrahp} from '../functions/functions';
import { uploadImages, uploadVideos, uploadCerts } from '../api/wordpressApi';
import { createGem } from '../api/backendApi';
import { generateGemDescription } from '../api/geminiApi';

import UploadFileIcon from '@mui/icons-material/UploadFile';
import DescriptionIcon from '@mui/icons-material/Description';

export default function GemsCreate() {

    const [seller, setSeller] = useState('');
    const [type, setType] = useState('');
    const [weight, setWeight] = useState('');
    const [shape, setShape] = useState('');
    const [width, setWidth] = useState('');
    const [length, setLength] = useState('');
    const [depth, setDepth] = useState('');
    const [color, setColor] = useState('');
    const [clarity, setClarity] = useState('');
    const [origin, setOrigin] = useState('');
    const [treatment, setTreatment] = useState('');
    const [certificate, setCertificate] = useState([]);
    const [images, setImages] = useState([]);
    const [videos, setVideos] = useState([]);
    const [certimgs, setCertimgs] = useState([]);
    const [price, setPrice] = useState('');
    const [priceOption, setPriceOption] = useState('sale');
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');

    const [isGenerating, setIsGenerating] = useState(false);
    const [error, setError] = useState(null);
    const [showError, setShowError] = useState(false);

    const handlePriceOption = (event) => {
        setPriceOption(event.target.value);
    };

    const gem = {
        "seller": seller,
        "type": type,
        "weight": weight,
        "shape": shape,
        "width": width,
        "length": length,
        "depth": depth,
        "color": color,
        "clarity": clarity,
        "origin": origin,
        "treatment": treatment,
        "certificate": certificate,
        "images": images,
        "videos": videos,
        "certimgs": certimgs,
        "price":price,
        "priceOption":priceOption,
        "title":title,
        "description":description
    };

    const [isImagesPicked, setIsImagesPicked] = useState(false);
    const [isUploaded, setIsUploaded] = useState(false);

    const [imageFilesSelect, setImageFilesSelect] = useState([]);
    const [videoFilesSelect, setVideFilesSelect] = useState([]);
    const [certimgFilesSelect, setCertimgFileSelect] = useState([]);

    const [isUploading,setIsuploading] = useState(false);
    const [status,setStatus] = useState('');
    const [listedId,setListId] = useState('');

    const selectImages = (e) => {
        setIsImagesPicked(true)
        console.log(e.target.files)
        setImageFilesSelect(Array.prototype.slice.call(e.target.files))
    };
    const selectVideos = (e) => {
        setVideFilesSelect(Array.prototype.slice.call(e.target.files))
    };
    const selectCerts = (e) => {
        setCertimgFileSelect(Array.prototype.slice.call(e.target.files))
    };

    const handleConsolelog = event => {
        console.log(gem)
    }
    const isTitleMorethan80 = (title) => {
        if(title.length>80){
            return true
        }else{
            return false
        }
    }

    const uploadImages = (imageFilesSelected) => {
        return new Promise(async (resolve,reject)=>{
            const ImagesList = [];
            setIsuploading(true);
            for (let i = 0; i < imageFilesSelected.length; i++) {
                setStatus("Uploading Image : " + imageFilesSelected[i].name);
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "image/jpeg");
                myHeaders.append(
                    "Content-Disposition",
                    "form-data; filename=\"" + imageFilesSelected[i].name + "\""
                );
                myHeaders.append(
                    "Authorization",
                    "Basic c29tcHJhc29uZzpwWGRoIGM1bmkgS0dJZiBPU0xBIEhiSkEgSDZPTg=="
                );
                var requestOptions = {
                    method: 'POST',
                    headers: myHeaders,
                    body: imageFilesSelected[i],
                    redirect: 'follow'
                };
                await fetch("https://gemnoble.com/wp-json/wp/v2/media", requestOptions)
                    .then(
                        response => response.text()
                    )
                    .then(result => {
                        ImagesList.push(JSON.parse(result))
                        console.log(
                            "Uploaded : " + imageFilesSelected[i].name + " URL:" + JSON.parse(result).media_details.sizes.woocommerce_thumbnail.source_url
                        )
                    })
                    .catch(error => reject(error));
            }
            
            resolve(ImagesList);
            setIsuploading(false);
            setStatus("Uploaded Image done");
        })
    }

    const uploadVideos = (videoFilesSelected) => {
        return new Promise(async (resolve,reject)=>{
            const VideosList = [];
            setIsuploading(true);
            for (let i = 0; i < videoFilesSelected.length; i++) {

                setStatus("Uploading Video : " + videoFilesSelected[i].name)
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "image/jpeg");
                myHeaders.append(
                    "Content-Disposition",
                    "form-data; filename=\"" + videoFilesSelected[i].name + "\""
                );
                myHeaders.append(
                    "Authorization",
                    "Basic c29tcHJhc29uZzpwWGRoIGM1bmkgS0dJZiBPU0xBIEhiSkEgSDZPTg=="
                );
                var requestOptions = {
                    method: 'POST',
                    headers: myHeaders,
                    body: videoFilesSelected[i],
                    redirect: 'follow'
                };
                await fetch("https://gemnoble.com/wp-json/wp/v2/media", requestOptions)
                    .then(
                        response => response.text()
                    )
                    .then(result => {

                        VideosList.push(JSON.parse(result))
                        console.log(
                            "Uploaded : " + videoFilesSelected[i].name + " URL:" + JSON.parse(result).source_url
                        )

                    })
                    .catch(error => reject(error));

            }
            resolve(VideosList);
            setIsuploading(false);
            setStatus("Uploaded Video done");

        })
    }

    const uploadCerts = (certimgFilesSelected) => {
        return new Promise(async (resolve,reject)=>{
            const CertsList = [];
            setIsuploading(true);
            for (let i = 0; i < certimgFilesSelected.length; i++) {

                setStatus("Uploading Certificate : " + certimgFilesSelected[i].name)
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "image/jpeg");
                myHeaders.append(
                    "Content-Disposition",
                    "form-data; filename=\"" + certimgFilesSelected[i].name + "\""
                );
                myHeaders.append(
                    "Authorization",
                    "Basic c29tcHJhc29uZzpwWGRoIGM1bmkgS0dJZiBPU0xBIEhiSkEgSDZPTg=="
                );
                var requestOptions = {
                    method: 'POST',
                    headers: myHeaders,
                    body: certimgFilesSelected[i],
                    redirect: 'follow'
                };
                await fetch("https://gemnoble.com/wp-json/wp/v2/media", requestOptions)
                    .then(
                        response => response.text()
                    )
                    .then(result => {
                        CertsList.push(JSON.parse(result))
                        console.log(
                            "Uploaded : " + certimgFilesSelected[i].name + " URL:" + JSON.parse(result).media_details.sizes.woocommerce_thumbnail.source_url
                        )

                    })
                    .catch(error => reject(error));

            }
            resolve(CertsList);
            setIsuploading(false);
            setStatus("Uploaded Certificate done");

        })
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if(isTitleMorethan80(title)){
            Swal.fire({
                icon: "error",
                title: "Title more than 80",
                text: 'Please edit title '
              })
            
        }
        else if (!isImagesPicked ){
          Swal.fire({
            icon: "error",
            title: "Please Select Photo",
            text: ' '
          })
        } else {
          var imagess = [];
          var videoss = [];
          var certimgss = [];

          uploadImages(imageFilesSelect,setIsuploading,setStatus)
            .then(data => {
                setImages(data);
                imagess = data ;
                uploadVideos(videoFilesSelect,setIsuploading,setStatus)

                .then(data =>{
                    setVideos(data);
                    videoss = data ;
                    uploadCerts(certimgFilesSelect,setIsuploading,setStatus)
                
                    .then(data =>{
                        setCertimgs(data);
                        certimgss = data ;


                        var gemm = JSON.stringify({
                        "seller": seller,
                        "type": type,
                        "weight": weight,
                        "shape": shape,
                        "width": width,
                        "length": length,
                        "depth": depth,
                        "color": color,
                        "clarity": clarity,
                        "origin": origin,
                        "treatment": treatment,
                        "certificate": certificate,
                        "price":price,
                        "priceOption":priceOption,
                        "images": imagess,
                        "videos": videoss,
                        "certimgs": certimgss,
                        "title":title,
                        "description":description

                        });

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/json");
                        var requestOptions = {
                        method: 'POST',
                        headers: myHeaders,
                        body:gemm,
                        redirect: 'follow'
                    };
                    fetch("https://app.gemnoble.com:2005/gems/create", requestOptions)
                    .then(
                        response => response.json()
                    )
                    .then(result => {
                        //alert(result['message']);
                        setStatus("Posted Successfully ID : "+ result['id']);
                        setIsUploaded(true);
                        if (result['status'] === 'ok') {
                            //window.location.href = '/update/' + result['id'];
                            setListId(result['id']);
                        }
                    })
                    .catch(error =>  setStatus('error', error));
                
              })
              .catch(error => {
                console.error(error);
              })
            })
            .catch(error => {
              console.error(error);
            })
          })
          .catch(error => {
            console.error(error);
          })

          
        }
        
    }

    const handleGenerateDescription = async () => {
        setIsGenerating(true);
        setError(null);
        try {
            const gemData = {
                type: gem.type,
                weight: gem.weight,
                shape: gem.shape,
                color: gem.color,
                clarity: gem.clarity,
                origin: gem.origin,
                treatment: gem.treatment,
                certificate: gem.certificate
            };

            const result = await generateGemDescription(gemData);
            setTitle(result.title);
            setDescription(result.description);
        } catch (err) {
            console.error('Error generating description:', err);
            setError(err.message || 'Failed to generate description');
            setShowError(true);
        } finally {
            setIsGenerating(false);
        }
    };

    return (

        <React.Fragment>
            <CssBaseline/>
            <Container maxWidth="sm" sx={{
                    p: 2
                }}>

                <Box display="flex">
                    <Box sx={{
                            flexGrow: 1
                        }}>
                        <Typography variant="h6" gutterBottom>
                            Create Gems
                        </Typography>
                    </Box>

                </Box>

                <form id="gem-form" onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}></Grid>

                        <Grid item xs={12} sm={6}>
                            <Box
                                sx={{
                                    minWidth: 120
                                }}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Seller</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="seller-select"
                                        value={seller}
                                        label="Seller"
                                        required
                                        onChange={(e) => setSeller(e.target.value)}>
                                        {
                                            sellerLists.map((sellerlist) => (
                                                <MenuItem key={sellerlist.key} value={sellerlist.key}>{sellerlist.value}</MenuItem>
                                            ))
                                        }

                                    </Select>
                                </FormControl>
                            </Box>

                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Box
                                sx={{
                                    minWidth: 120
                                }}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label" required>Gemtype</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="type-select"
                                        value={type}
                                        label="Gemtype"
                                        required
                                        onChange={(e) => setType(e.target.value)}>
                                        {
                                            gemtypeLists.map((gemtypeLists) => (
                                                <MenuItem key={gemtypeLists.key} value={gemtypeLists.key}>{gemtypeLists.value}</MenuItem>
                                            ))
                                        }

                                    </Select>
                                    
                                    

                                </FormControl>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                                <TextField
                                    id="weight"
                                    value={weight}
                                    type="number"
                                    label="Gem Weight"
                                    variant="outlined"
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">Ct</InputAdornment>
                                    }}
                                    fullWidth
                                    required
                                    inputProps={{ min: 0, max: 1000 }}
                                    error={weight < 0 || weight > 1000}
                                    helperText={weight < 0 || weight > 1000 ? 'Weight must be between 0 and 1000 Ct' : ''}
                                    onChange={(e) => setWeight(e.target.value)}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label" required>Shape</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="shape-select"
                                    value={shape}
                                    label="Seller"
                                    required
                                    onChange={(e) => setShape(e.target.value)}>
                                    {
                                        shapeLists.map((shapelist) => (
                                            <MenuItem key={shapelist.key} value={shapelist.key}>{shapelist.value}</MenuItem>
                                        ))
                                    }

                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                                <TextField
                                    id="width"
                                    value={width}
                                    type="number"
                                    label="Width"
                                    variant="outlined"
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">mm.</InputAdornment>
                                    }}
                                    fullWidth
                                    required
                                    inputProps={{ min: 0, max: 100 }}
                                    error={width < 0 || width > 100}
                                    helperText={width < 0 || width > 100 ? 'Width must be between 0 and 100 mm' : ''}
                                    onChange={(e) => setWidth(e.target.value)}/>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                                <TextField
                                    id="length"
                                    value={length}
                                    type="number"
                                    label="Length"
                                    variant="outlined"
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">mm.</InputAdornment>
                                    }}
                                    fullWidth
                                    required
                                    inputProps={{ min: 0, max: 100 }}
                                    error={length < 0 || length > 100}
                                    helperText={length < 0 || length > 100 ? 'Length must be between 0 and 100 mm' : ''}
                                    onChange={(e) => setLength(e.target.value)}/>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                                <TextField
                                    id="depth"
                                    value={depth}
                                    type="number"
                                    label="Depth"
                                    variant="outlined"
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">mm.</InputAdornment>
                                    }}
                                    fullWidth
                                    required
                                    inputProps={{ min: 0, max: 100 }}
                                    error={depth < 0 || depth > 100}
                                    helperText={depth < 0 || depth > 100 ? 'Depth must be between 0 and 100 mm' : ''}
                                    onChange={(e) => setDepth(e.target.value)}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label" required>Color</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="color-select"
                                    value={color}
                                    label="Color"
                                    required
                                    onChange={(e) => setColor(e.target.value)}>
                                    {
                                        colorLists.map((colorlist) => (
                                            <MenuItem key={colorlist.key} value={colorlist.key}>{colorlist.value}</MenuItem>
                                        ))
                                    }

                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label" required>Clarity</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="clarity-select"
                                    value={clarity}
                                    label="Clarity"
                                    required
                                    onChange={(e) => setClarity(e.target.value)}>
                                    {
                                        clarityLists.map((colorlist) => (
                                            <MenuItem key={colorlist.key} value={colorlist.key}>{colorlist.value}</MenuItem>
                                        ))
                                    }

                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label" required>Origin</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="origin-select"
                                    value={origin}
                                    label="Origin"
                                    required
                                    onChange={(e) => setOrigin(e.target.value)}>
                                    {
                                        originLists.map((originlist) => (
                                            <MenuItem key={originlist.key} value={originlist.key}>{originlist.value}</MenuItem>
                                        ))
                                    }

                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label" required>Treathment</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="treathment-select"
                                    value={treatment}
                                    label="Treathment"
                                    required
                                    onChange={(e) => setTreatment(e.target.value)}>
                                    {
                                        treatmentLists.map(
                                            (heatlist) => (<MenuItem key={heatlist.key} value={heatlist.key}>{heatlist.value}</MenuItem>)
                                        )
                                    }

                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>

                            <Select
                                labelId="demo-multiple-checkbox-label"
                                id="certificate-multiple-checkbox"
                                label="Certificate"
                                multiple
                                fullWidth
                                value={certificate}
                                onChange={(e) => {
                                  const {target: {
                                          value
                                      }} = e;
                                  setCertificate(
                                      // On autofill we get a stringified value.
                                          typeof value === 'string'
                                          ? value.split(',')
                                          : value,
                                  );
                              }}
                                input={<OutlinedInput label = "" />}
                                renderValue={(selected) => selected.join(', ')}>
                                {
                                    certs.map((cert) => (
                                        <MenuItem key={cert} value={cert}>
                                            <Checkbox checked={certificate.indexOf(cert) > -1}/>
                                            <ListItemText primary={cert}/>
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="outlined-adornment-amount"
                                type="number"
                                label="Price"
                                value={price}
                                onChange={e => {
                                    setPrice(e.target.value);
                                    setTitle(CreateTitle(gem));
                                    setDescription(CreateParagrahp(gem));
                                }}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">$</InputAdornment>
                                }}
                                inputProps={{ min: 0, max: 1000000 }}
                                error={price < 0 || price > 1000000}
                                helperText={price < 0 || price > 1000000 ? 'Price must be between $0 and $1,000,000' : ''}
                            />
                        </Grid>
                        <Grid item xs={12} >
                        <FormControl>
                                <FormLabel id="demo-controlled-radio-buttons-group" required>Price Option</FormLabel>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={priceOption}
                                    onChange={handlePriceOption}
                                    required
                                >
                            <FormControlLabel value="open" control={<Radio />} label="Open Price" />
                            <FormControlLabel value="sale" control={<Radio />} label="Sale Price" />
                            
                        </RadioGroup>
                        </FormControl>

                        </Grid>
                        

                        <Grid item xs={12}>
                            <Paper sx={{ p: 3, mb: 3 }}>
                                <Typography variant="h6" gutterBottom>
                                    Images Upload
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Paper
                                            variant="outlined"
                                            sx={{
                                                p: 3,
                                                border: '2px dashed #ccc',
                                                textAlign: 'center',
                                                cursor: 'pointer',
                                                '&:hover': {
                                                    borderColor: 'primary.main',
                                                    backgroundColor: 'action.hover'
                                                }
                                            }}
                                            onClick={() => document.getElementById('image-upload').click()}
                                        >
                                            <input
                                                id="image-upload"
                                                type="file"
                                                name="file"
                                                multiple
                                                accept=".JPG"
                                                onChange={selectImages}
                                                style={{ display: 'none' }}
                                            />
                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                                <UploadFileIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
                                                <Typography variant="body1">
                                                    Click to upload images or drag and drop
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary">
                                                    JPG files only
                                                </Typography>
                                            </Box>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {isImagesPicked ? (
                                            <>
                                                <ImageList
                                                    sx={{
                                                        width: '100%',
                                                        height: 500
                                                    }}
                                                    cols={3}
                                                    rowHeight={164}>
                                                    {imageFilesSelect.map((item) => (
                                                        <ImageListItem key={item.name}>
                                                            <img 
                                                                src={URL.createObjectURL(item)}
                                                                alt={item.name}
                                                                loading="lazy"
                                                            />
                                                        </ImageListItem>
                                                    ))}
                                                </ImageList>
                                                <Box sx={{ mt: 2 }}>
                                                    <Typography variant="body2" color="text.secondary">
                                                        {status.includes('Image') ? status : ''}
                                                    </Typography>
                                                    {status.includes('Image') && <LinearProgress />}
                                                </Box>
                                            </>
                                        ) : null}
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>

                        <Grid item xs={12}>
                            <Paper sx={{ p: 3, mb: 3 }}>
                                <Typography variant="h6" gutterBottom>
                                    Videos Upload
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Paper
                                            variant="outlined"
                                            sx={{
                                                p: 3,
                                                border: '2px dashed #ccc',
                                                textAlign: 'center',
                                                cursor: 'pointer',
                                                '&:hover': {
                                                    borderColor: 'primary.main',
                                                    backgroundColor: 'action.hover'
                                                }
                                            }}
                                            onClick={() => document.getElementById('video-upload').click()}
                                        >
                                            <input
                                                id="video-upload"
                                                type="file"
                                                name="file"
                                                multiple
                                                accept=".mp4"
                                                onChange={selectVideos}
                                                style={{ display: 'none' }}
                                            />
                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                                <UploadFileIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
                                                <Typography variant="body1">
                                                    Click to upload videos or drag and drop
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary">
                                                    MP4 files only
                                                </Typography>
                                            </Box>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box
                                            component="ul"
                                            sx={{
                                                display: 'flex',
                                                gap: 2,
                                                flexWrap: 'wrap',
                                                p: 0,
                                                m: 0
                                            }}>
                                            {videoFilesSelect.map((item) => (
                                                <Card
                                                    key={item.name}
                                                    component="li"
                                                    sx={{
                                                        width: 500,
                                                        height: 500
                                                    }}>
                                                    <CardCover>
                                                        <video autoPlay loop muted>
                                                            <source src={URL.createObjectURL(item)} type="video/mp4"/>
                                                        </video>
                                                    </CardCover>
                                                </Card>
                                            ))}
                                        </Box>
                                        <Box sx={{ mt: 2 }}>
                                            <Typography variant="body2" color="text.secondary">
                                                {status.includes('Video') ? status : ''}
                                            </Typography>
                                            {status.includes('Video') && <LinearProgress />}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>

                        <Grid item xs={12}>
                            <Paper sx={{ p: 3, mb: 3 }}>
                                <Typography variant="h6" gutterBottom>
                                    Certificates Upload
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Paper
                                            variant="outlined"
                                            sx={{
                                                p: 3,
                                                border: '2px dashed #ccc',
                                                textAlign: 'center',
                                                cursor: 'pointer',
                                                '&:hover': {
                                                    borderColor: 'primary.main',
                                                    backgroundColor: 'action.hover'
                                                }
                                            }}
                                            onClick={() => document.getElementById('cert-upload').click()}
                                        >
                                <input
                                id="cert-upload"
                                type="file"
                                name="file"
                                accept=".pdf"
                                multiple
                                required
                                onChange={selectCerts}
                                style={{ display: 'none' }}
                            />
                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                                <UploadFileIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
                                                <Typography variant="body1">
                                                    Click to upload certificates or drag and drop
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary">
                                                    PDF files only
                                                </Typography>
                                            </Box>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box
                                            component="ul"
                                            sx={{
                                                display: 'flex',
                                                gap: 2,
                                                flexWrap: 'wrap',
                                                p: 0,
                                                m: 0
                                            }}>
                                            {certimgFilesSelect.map((item) => (
                                                <Card
                                                    key={item.name}
                                                    component="li"
                                                    sx={{
                                                        width: 500,
                                                        height: 500
                                                    }}>
<CardCover>
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2 }}>
        <DescriptionIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
        <Typography variant="body2">{item.name}</Typography>
        <Button size="small" href={URL.createObjectURL(item)} target="_blank" rel="noopener noreferrer">
            View PDF
        </Button>
    </Box>
</CardCover>
                                                </Card>
                                            ))}
                                        </Box>
                                        <Box sx={{ mt: 2 }}>
                                            <Typography variant="body2" color="text.secondary">
                                                {status.includes('Certificate') ? status : ''}
                                            </Typography>
                                            {status.includes('Certificate') && <LinearProgress />}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                        <Grid item xs={12}>
                            <Paper sx={{ p: 3, mb: 3 }}>
                                <Typography variant="h6" gutterBottom>
                                    Description
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                                            <TextField
                                                fullWidth
                                                label="Title"
                                                name="title"
                                                value={title}
                                                onChange={e => setTitle(e.target.value)}
                                                error={isTitleMorethan80(title)}
                                                helperText={isTitleMorethan80(title) ? 'Title must be less than 80 characters' : ''}
                                                required
                                            />
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={handleGenerateDescription}
                                                disabled={isGenerating || !weight || !shape || !color || !clarity || !origin || !treatment}
                                                sx={{ minWidth: '120px', height: '56px' }}
                                            >
                                                {isGenerating ? 'Generating...' : 'Generate'}
                                            </Button>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Description"
                                            name="description"
                                            value={description}
                                            onChange={e => setDescription(e.target.value)}
                                            multiline
                                            rows={4}
                                            required
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                        <Grid item xs={12}>
                        <Box sx={{ width: '100%' }}>
                          <Typography>
                            {status}
                            </Typography>
                        </Box>
                        <Box sx={{ width: '100%' }}>
                          {isUploading?(<LinearProgress />):(<div></div>)}
                          
                        </Box>

                          
                        </Grid>

                        <Grid item xs={12}></Grid>

                        <Grid item xs={12}>
                            {
                                isUploaded?
                                (<Button  variant='contained' fullWidth onClick={e=>{e.preventDefault();window.location.href = '/update/'+listedId;}}>View</Button>)
                                :
                                (<Button type="submit" variant='contained' fullWidth>Post</Button>)
                            }
                        

                        </Grid>

                        

                        <Grid item xs={12}>

                            
                                {true?(<div></div>):(<Button
                                onClick={handleConsolelog}
                                variant='contained'
                                fullWidth
                                
                                >CONSOLELOG</Button>)}
                        </Grid>

                        

                    </Grid>
                </form>

            </Container>

            <Snackbar
                open={showError}
                autoHideDuration={6000}
                onClose={() => setShowError(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={() => setShowError(false)} severity="error" sx={{ width: '100%' }}>
                    {error}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}
